import { Button } from 'react-bootstrap'
import { AccordionAdjuntos } from './AccordionAdjuntos'
import { LanguageTranslate } from '../../Infraestructure/LanguageTranslate'
import { DtoHPListType } from '../../Domain/Dto/DtoHPListType'
import { useState } from 'react'
import { NodoDocDTO } from 'sigo-entities'

interface IPropsAdjuntos {
  Nodos: NodoDocDTO[]
  setNodos: React.Dispatch<React.SetStateAction<NodoDocDTO[]>>
  setNewFiles: React.Dispatch<React.SetStateAction<File[]>>
  newFiles: File[]
  ruta: string
  onSave?: () => void | Promise<void>
  colorNodos?: boolean
  btnDelete?: boolean
  btnAdjuntar?: boolean
  loading?: boolean
  //#region Solo para Alemania Caso especial
  dataAddress?: DtoHPListType[]
  //#endregion Solo para Alemania Caso especial
  capture?: boolean | undefined
  validateMetadata?: boolean
}

export const AdjuntosV1 = (props: IPropsAdjuntos) => {

  const {
    Nodos,
    newFiles,
    setNewFiles,
    setNodos,
    ruta,
    onSave,
    colorNodos,
    dataAddress = [],
    btnDelete,
    btnAdjuntar,
    loading,
    capture,
    validateMetadata = false
  } = props
  const langTranslate = LanguageTranslate()
  const [save, SetSave] = useState<boolean>(true)

  return (
    <div className='h-100 d-flex flex-column justify-content-between'>
      <AccordionAdjuntos
        Nodos={Nodos}
        NodoPrincipal={Nodos}
        newFiles={newFiles}
        setNewFiles={setNewFiles}
        ruta={ruta}
        setNodos={setNodos}
        colorNodos={colorNodos}
        dataAddress={dataAddress}
        save={save}
        btnDelete={btnDelete}
        btnAdjuntar={btnAdjuntar}
        capture={capture}
        validateMetadata={validateMetadata}
      />
      {
        onSave &&
        <Button
          onClick={async () => {
            await onSave()
            SetSave(prev => !prev)
          }}
          className='mt-3'
          disabled={loading}
        >
          {loading ? 'Cargando…' : 'Guardar Adjuntos'}
        </Button>
      }
    </div>
  )
}
